
import { getActions } from '../sagas';

 /**
 * Command `data.setDatawinObjectList`
 *
 * @typedef {Object} MultSceneForApp~Data~Commands~SetDatawinDataModelItemId
 * @property {string} command - name of command, has value `data.setDatawinObjectList`
 * @property {string} dataModelItemId - ID of data model item
 * @property {Object} objectList - list of objects
 * @property {string} mode - mode of objects operation (ADD, FILTER, REMOVE, SET)
 */
function setDatawinObjectList(params, dispatch, store) {
    const dataActions = getActions(dispatch);

    dataActions.setDatawinObjectList(params.dataModelItemId, params.objectList, params.mode);
}

export default {
    name: 'data.setDatawinObjectList',
    execute: setDatawinObjectList
}
